module.exports = __webpack_public_path__ + "img/art-16.f391b385.png";